import React, { useState } from "react";
import Modal from "components/Modal/Modal";
import { useLocation } from "react-router";
import { Tooltip } from "react-tooltip";
import { useMsal } from "@azure/msal-react";

const toTitleCase = (value) =>
  value
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

const getNameFromEmail = (email = "") => {
  const normalizedEmail = String(email || "");
  const localPart = normalizedEmail.split("@")[0] || "";
  const spacedName = localPart.replace(/[._-]+/g, " ").trim();
  return spacedName ? toTitleCase(spacedName) : "";
};

const resolveDisplayName = ({ storedDisplayName, username, accountName }) => {
  const normalizedUsername = String(username || "").trim();

  return (
    storedDisplayName?.trim() ||
    accountName?.trim() ||
    getNameFromEmail(normalizedUsername) ||
    normalizedUsername ||
    "User"
  );
};

export default function AdminNavbar() {
  const [username] = useState(() => localStorage.getItem("username"));
  const [storedDisplayName] = useState(() => localStorage.getItem("displayName"));
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount?.() || accounts?.[0];
  const displayName = resolveDisplayName({
    storedDisplayName,
    username,
    accountName: activeAccount?.name,
  });
  const location = useLocation();
  const selectedProject = localStorage.getItem("selectedProject");
  const [isModalOpen, setModalOpen] = useState(false);
  const modalContent = `
  <p><strong>Guidelines for Formulating Questions</strong></p>
  <p>To obtain accurate and detailed answers from the Abstract texts or PDF documents, please follow these guidelines when formulating your questions:</p>
  <ul>
      <li><strong>Be Specific:</strong> Clearly define what information you are seeking. Include specific terms, metrics, or details that are relevant to the question.</li>
      <li><strong>Avoid Ambiguity:</strong> Frame your questions in a way that leaves little room for interpretation. Ambiguous questions may lead to incomplete or incorrect answers.</li>
      <li><strong>Consider Context:</strong> If your question relates to a specific section, table, or figure in the document, mention it in your question.</li>
      <li><strong>Use Proper Terminology:</strong> Utilize the terminology and language that is consistent with the subject matter of the document.</li>
      <li><strong>Limit One Query per Question:</strong> Asking multiple questions in one query can lead to confusion. Break down complex queries into individual, focused questions.</li>
      <li><strong>Include Relevant Categories:</strong> If applicable, specify the category or aspect of the study you are inquiring about, such as design, population characteristics, interventions, etc.</li>
      <li><strong>Understanding "OR" Logic:</strong> If you provide multiple questions within the same category, the system uses an "OR" logic. This means that if the answer to any one of the questions is "yes", the overall answer for that category will be considered "yes". Craft your questions accordingly to make use of this logic when necessary.</li>
  </ul>
  <p>By adhering to these guidelines, you will help the system understand your inquiry better, leading to more precise and informative answers.</p>
  
  `;
  return (
    <>
      {/* Navbar */}
      <nav className="relative top-0 left-0 w-full z-10 bg-lightBlue-600 md:flex-row md:flex-nowrap md:justify-start flex items-center p-3">
        <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap p-4">
          <span className="text-white text-sm uppercase hidden lg:inline-block font-semibold">
            {location.pathname === "/dashboard/my-projects"
              ? "dashboard"
              : selectedProject}
          </span>
          <div>
            <Tooltip id="nav-btn-tooltip" />
            {/* User */}
            {location.pathname === "/dashboard/my-projects" ? (
              ""
            ) : (
              <>
                <button
                  className="bg-teal-500 text-white active:bg-teal-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 mr-2"
                  type="button"
                  onClick={() => setModalOpen(true)}
                  data-tooltip-id="nav-btn-tooltip"
                  data-tooltip-content="Guidance on using the app."
                  data-tooltip-delay-show="1000"
                >
                  <i className="fas fa-circle-info"></i> HELP
                </button>
              </>
            )}
            <span className="text-white text-sm hidden lg:inline-block font-semibold">
              <i className="fas fa-user-circle mr-1"></i>
              Hello {displayName}
            </span>
          </div>
          <Modal
            show={isModalOpen}
            title="Important Note:"
            content={modalContent}
            onClose={() => setModalOpen(false)}
          ></Modal>

          {/* <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
            <UserDropdown />
          </ul> */}
        </div>
      </nav>
    </>
  );
}
